/**
 * 在 URL 字符串中替换指定域名，同时保留其他部分（路径、参数、hash、端口等）
 *
 * - intl.yofogo.com  -> intl.fanxinggj.com
 * - foreign.yofogo.com -> foreign.fanxinggj.com
 *
 * @param {string} urlStr - 输入的 URL（可以是完整 URL 或相对路径）
 * @param {Object} [opts]
 * @param {boolean} [opts.allowSubdomain=false] - 是否允许匹配带子域名的情况（例如 www.intl.yofogo.com）
 * @returns {string} - 替换后的 URL（如果不匹配则返回原字符串）
 */
const replaceYofogoDomains = (urlStr, opts = {}) => {
  const { allowSubdomain = false } = opts;

  // 需要替换的域名映射表
  const replacements = {
    'intl.yofogo.com': 'intl.fanxinggj.com',
    'foreign.yofogo.com': 'foreign.fanxinggj.com'
  };
  // 读取当前浏览器地址栏的完整 URL
  const currentUrl = window.location.href;
  try {
    // 将字符串解析为 URL 对象（仅支持绝对路径）
    const u = new URL(urlStr || currentUrl);

    // 遍历替换规则
    for (const [oldHost, newHost] of Object.entries(replacements)) {
      if (u.hostname === oldHost) {
        u.hostname = newHost;
        return u.toString();
      }

      // 允许子域名匹配（例如 xxx.intl.yofogo.com）
      if (allowSubdomain && u.hostname.endsWith('.' + oldHost)) {
        // 提取前缀部分（保留子域名前缀）
        const prefix = u.hostname.slice(0, u.hostname.length - oldHost.length);
        u.hostname = prefix + newHost;
        return u.toString();
      }
    }

    return urlStr;
  } catch (err) {
    // 解析失败（说明不是绝对 URL，比如相对路径），回退到字符串替换
    let s = urlStr;

    Object.keys(replacements).forEach((oldHost) => {
      const newHost = replacements[oldHost];

      if (allowSubdomain) {
        // 匹配带子域名的情况（例如 www.intl.yofogo.com 或 intl.yofogo.com）
        // 使用正则匹配并保留子域名前缀部分
        const regex = new RegExp('(?:([a-z0-9-]+)\\.)?' + oldHost.replace(/\./g, '\\.'), 'gi');
        s = s.replace(regex, (match, sub) => {
          // 如果匹配到前缀，则加上前缀
          if (sub) return sub + '.' + newHost;
          return newHost;
        });
      } else {
        // 仅替换完整匹配的域名，不替换部分匹配
        const regex = new RegExp('\\b' + oldHost.replace(/\./g, '\\.') + '\\b', 'gi');
        s = s.replace(regex, newHost);
      }
    });

    return s;
  }
};

/**
 * 检查 URL 是否为旧域名
 *
 * @returns {boolean} - 是否为旧域名
 */
const isOldUrl = () => {
  const oldHosts = ['intl.yofogo.com', 'foreign.yofogo.com'];
  const hostname = new URL(window.location.href).hostname;

  const isOldHost = oldHosts.includes(hostname);
  return isOldHost;
};

export { replaceYofogoDomains, isOldUrl };



// WEBPACK FOOTER //
// ./src/function/yofogoDomains.js